export default __webpack_public_path__ + "static/media/ewm.ec8eed2c.jpg";